export default __webpack_public_path__ + "static/media/image.valueaura.0caf299e.png";